export default __webpack_public_path__ + "static/winter22-90c25b824898b4d2e78d0b5164b1a28c.webp";